import { Component } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { TranslateModule } from '@ngx-translate/core';
import { UrlConstants } from '@shared/constants/url.constant';

@Component({
	selector: 'rt-access-denied',
	imports: [TranslateModule],
	templateUrl: './access-denied.component.html',
	styleUrls: ['./access-denied.component.scss'],
	standalone: true,
})
export class AccessDeniedComponent {
	public externalMail = 'userid@ext.volvogroup.com';
	public volvoMail = 'firstname.lastname@volvo.com';
	public renaultTruckMail = 'firstname.lastname@renault-trucks.com';
	public readonly CSM_URL = UrlConstants.CUSTOMER_SERVICE_PORTAL_URL;
	public readonly BUSINESS_APPLICATION_URL = UrlConstants.BUSINESS_APPLICATION_URL;

	constructor(private readonly msalService: MsalService) {}

	public login(): void {
		this.msalService.instance.clearCache();
		this.msalService.loginRedirect();
	}
}
